module.exports = __webpack_public_path__ + "03_veryshort_gray.298acb16.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_veryshort_gray.png
// module id = LtIN
// module chunks = 0